import PropTypes from 'prop-types';

// Transparent full-message overlay that switches to the discussion a message belongs to. Rendered
// only for messages from another discussion (dimmed) so the current one keeps its normal interactions.
const ChatItemClick = function ChatItemClick({
  gthrId,
  selectGathering,
  visibleInThisGathering,
}) {
  if ((!selectGathering) || visibleInThisGathering) return null;

  return (
    <button
      type="button"
      onClick={() => { selectGathering(gthrId); }}
      aria-label="Select discussion"
      className="absolute inset-0 z-10"
    />
  );
};

ChatItemClick.propTypes = {
  gthrId: PropTypes.number,
  selectGathering: PropTypes.func,
  visibleInThisGathering: PropTypes.bool,
};

export default ChatItemClick;
